import { render, staticRenderFns } from "./LogIn.vue?vue&type=template&id=20d99fa4&"
import script from "./LogIn.vue?vue&type=script&lang=js&"
export * from "./LogIn.vue?vue&type=script&lang=js&"
import style0 from "./LogIn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports